import { DataSettings } from './DataSetting';
import type { IGlobalStyle, IDataSettingGlobalStyle } from './interface';

export class DataSettingGlobalStyle extends DataSettings implements IDataSettingGlobalStyle {
  public dataGlobalStyle: any = new Map();
  constructor(id: string) {
    super(id);
    this.dataGlobalStyle = this.getDataGlobalStyle();
  }
  /*
   * updateValueGS
   * param: {gsId: string, selector: string, class?: string}
   */
  updateValueGS(param: any) {
    const selector = param?.selector || '';
    const indexGS = this.dataGlobalStyle.findIndex((obj: any) => obj.key == param.gsId);
    let itemDataGs: any;
    if (indexGS < 0) {
      itemDataGs = {
        key: param.gsId,
        value: {
          selector: selector ? [selector] : [],
          currentClass: param.class,
        },
      };
      this.dataGlobalStyle.push(itemDataGs);
    } else {
      const itemDataGs = this.dataGlobalStyle[indexGS];
      const itemDataGsValue = itemDataGs.value;
      itemDataGsValue.currentClass = param.class ? param.class : itemDataGs.value.currentClass;
      const arrSelector = itemDataGsValue?.selector || [];
      if (selector && !arrSelector.includes(selector)) {
        arrSelector.push(selector);
      }
      this.dataGlobalStyle[indexGS] = itemDataGs;
    }
    this.setDataGlobalStyle();
    return false;
  }
  getItemDataGsByKey(gsId: string) {
    return this.dataGlobalStyle && this.dataGlobalStyle.length > 0
      ? this.dataGlobalStyle.find((item: IGlobalStyle) => {
          return item.key === gsId;
        })
      : false;
  }
  getCurrentClassGsByKey(gsId: string) {
    const itemDataGs = this.getItemDataGsByKey(gsId);
    const currentClass = itemDataGs?.value?.currentClass;
    return currentClass ? currentClass : '';
  }
  setDataGlobalStyle() {
    if (!this.dataSettingAtom) return;
    const data = this.getData();
    data.globalStyle = this.dataGlobalStyle;
    this.mergeDataForDataSettingAtom(data);
    return false;
  }

  /**
   * getDataGlobalStyle
   * Dùng khi init
   */
  getDataGlobalStyle(): IGlobalStyle[] {
    if (!this.dataSettingAtom) return [];
    const data = this.getData();
    return data?.globalStyle && data?.globalStyle.length > 0 ? data.globalStyle : [];
  }
}
